<template>
    <div class="editor-row customize-editor-minimize">
        <div class="editor-row-title">{{ $t('auto.stringFormatterSplitDelimiter') }}</div>
        <TiptapEditor
            placeholder="Delimiter: e.g. space, comma, etc."
            :show-attributes="true"
            v-model="clone.split.delimiter"
            :show-emoji="false"
            automation-mode
        />
        <small class="description">
            {{ $t('auto.stringFormatterSplitEnterTheCharacterOrStringThatWillBeUsedToSplitTheText') }}
        </small>
    </div>
</template>

<script>
import log2 from "../../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";

const log = log2("StringFormatterSplit");
export default {
    name: "StringFormatterSplit",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "string.split",
            value: "",
            split: {
                delimiter: " ",
            }
        };
        return {
            clone,
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.editor-row {
    width: 100%;

    &.customize-editor-minimize {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    small.description {
        font-size: 10px;
        color: var(--color-text-weak-default);
    }

    .editor-row-title {
        font-weight: bold;
        font-size: 16px;
    }
}
</style> 